import React, { memo } from 'react'

import { useFormattedTourV2VariationDetailsCount } from 'hooks/TourV2/useTourV2VariationDetails'
import Modal from 'components/Luxkit/Modal/Modal'

interface Props {
  variation: Tours.V2OfferVariation;
  open: boolean;
  onClose: () => void;
}

function TourV2RouteMapModal(props: Props) {
  const { variation, open, onClose } = props

  const { variationDetailsCountText } = useFormattedTourV2VariationDetailsCount(variation)

  return (
    <Modal
      image={variation.routeMapImage}
      imageParams={{ quality: 'good' }}
      isOpen={open}
      size="large"
      subtitle={variationDetailsCountText}
      title={variation.name}
      onClose={onClose}
    />
  )
}

export default memo(TourV2RouteMapModal)
